import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditRoutineForm from './EditRoutineForm'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import RoutineLoader from './_load/RoutineLoader'

const EditRoutineModal = props => {
  return (
    <ControlledModal width="40rem" {...props}>
      <RoutineLoader>
        <PermissionChecker any={['createRoutine', 'editRoutine']}>
          <ModalHeader />

          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />
          <EditRoutineForm />
        </PermissionChecker>
      </RoutineLoader>
    </ControlledModal>
  )
}

export default EditRoutineModal
